module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-jack.550072df.svg";